// extracted by mini-css-extract-plugin
export default {"title":"Products_title__iPji+","description":"Products_description__7Mfhc"};